import { useTranslation } from 'react-i18next';
import { Box, Grid, Typography } from '@mui/material';
import { LwButton, LwFormDate, LwFormNumberInput } from 'redesign';
import { FlexWorkerContractProps } from './flex-worker-contract-body.types';
import { useFlexWorkerContractForm } from './useFlexWorkerContractForm';

export const FlexWorkerContractBody = ({ data, onClose }: FlexWorkerContractProps) => {
  const { t } = useTranslation('all-platforms-common');

  const { form, handleSubmit } = useFlexWorkerContractForm({ data, onClose });
  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      padding={6}
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      height="100%"
    >
      <Box>
        <Typography mb={2}>Stel de ingangs- en einddatum van het contract in</Typography>
        <Grid container spacing={4} xs={6}>
          <Grid item xs={6}>
            <LwFormDate
              control={form.control}
              name={'contractStartDate'}
              label={t('worker_data.contract_start_date', { ns: 'all-platforms-common' })}
            />
          </Grid>
          <Grid item xs={6}>
            <LwFormDate
              minDate={form.watch('contractStartDate')}
              control={form.control}
              name={'contractEndDate'}
              label={t('worker_data.contract_end_date', { ns: 'all-platforms-common' })}
            />
          </Grid>
          <Grid item xs={6}>
            <LwFormNumberInput
              control={form.control}
              name={'contractHours'}
              label={t('worker_data.contract_hours', { ns: 'all-platforms-common' })}
            />
          </Grid>
        </Grid>
      </Box>
      <Box display="flex" flexDirection="row" justifyContent="center">
        <LwButton type="submit">Indienen</LwButton>
        <Box ml={4}>
          <LwButton color="secondary" onClick={onClose}>
            Annuleren
          </LwButton>
        </Box>
      </Box>
    </Box>
  );
};
